import first from "../images/functions/1.png";
import second from "../images/functions/2.png";
import third from "../images/functions/3.png";
import fourth from "../images/functions/4.png";
import { useTranslation } from 'react-i18next';

function Functions() {
      const { t } = useTranslation();

      return (
            <>
                  <section className="expertise-section" style={{
                        padding: "5rem 0",
                        backgroundColor: "#f8f8f8"
                  }}>
                        <div className="container">
                              <h2 style={{
                                    textAlign: "center",
                                    fontSize: "3rem",
                                    marginBottom: "3rem"
                              }}>
                                    <span style={{ color: "#ff4d30" }}>{t('functions.mainTitle.part2')}</span> {t('functions.mainTitle.part1')} {t('functions.mainTitle.part3')}
                              </h2>

                              <div className="cards-container" style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, minmax(300px, 450px))",
                                    gap: "3rem",
                                    padding: "2rem",
                                    justifyContent: "center"
                              }}>
                                    {/* Card 1 */}
                                    <div className="card" style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                                    }}>
                                          <img src={first} alt={t('functions.cards.inspection360.title')} style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover"
                                          }} />
                                          <div style={{ padding: "2rem" }}>
                                                <h3 style={{ marginBottom: "1rem", fontSize: "1.8rem" }}>{t('functions.cards.inspection360.title')}</h3>
                                                <p style={{ marginBottom: "1.5rem", fontSize: "1.2rem", lineHeight: "1.6" }}>
                                                      {t('functions.cards.inspection360.description')}
                                                </p>
                                                <button style={{
                                                      padding: "1rem 2rem",
                                                      backgroundColor: "#ff4d30",
                                                      color: "white",
                                                      border: "none",
                                                      borderRadius: "5px",
                                                      cursor: "pointer",
                                                      fontSize: "1.1rem"
                                                }}>{t('functions.cards.inspection360.button')}</button>
                                          </div>
                                    </div>

                                    {/* Card 2 */}
                                    <div className="card" style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                                    }}>
                                          <img src={second} alt={t('functions.cards.virtualCar360.title')} style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover"
                                          }} />
                                          <div style={{ padding: "2rem" }}>
                                                <h3 style={{ marginBottom: "1rem", fontSize: "1.8rem" }}>{t('functions.cards.virtualCar360.title')}</h3>
                                                <p style={{ marginBottom: "1.5rem", fontSize: "1.2rem", lineHeight: "1.6" }}>
                                                      {t('functions.cards.virtualCar360.description')}
                                                </p>
                                                <button style={{
                                                      padding: "1rem 2rem",
                                                      backgroundColor: "#ff4d30",
                                                      color: "white",
                                                      border: "none",
                                                      borderRadius: "5px",
                                                      cursor: "pointer",
                                                      fontSize: "1.1rem"
                                                }}>{t('functions.cards.virtualCar360.button')}</button>
                                          </div>
                                    </div>

                                    {/* Card 3 */}
                                    <div className="card" style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                                    }}>
                                          <img src={third} alt={t('functions.cards.customer360.title')} style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover"
                                          }} />
                                          <div style={{ padding: "2rem" }}>
                                                <h3 style={{ marginBottom: "1rem", fontSize: "1.8rem" }}>{t('functions.cards.customer360.title')}</h3>
                                                <p style={{ marginBottom: "1.5rem", fontSize: "1.2rem", lineHeight: "1.6" }}>
                                                      {t('functions.cards.customer360.description')}
                                                </p>
                                                <button style={{
                                                      padding: "1rem 2rem",
                                                      backgroundColor: "#ff4d30",
                                                      color: "white",
                                                      border: "none",
                                                      borderRadius: "5px",
                                                      cursor: "pointer",
                                                      fontSize: "1.1rem"
                                                }}>{t('functions.cards.customer360.button')}</button>
                                          </div>
                                    </div>

                                    {/* Card 4 */}
                                    <div className="card" style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                                    }}>
                                          <img src={fourth} alt={t('functions.cards.offerManager.title')} style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "cover"
                                          }} />
                                          <div style={{ padding: "2rem" }}>
                                                <h3 style={{ marginBottom: "1rem", fontSize: "1.8rem" }}>{t('functions.cards.offerManager.title')}</h3>
                                                <p style={{ marginBottom: "1.5rem", fontSize: "1.2rem", lineHeight: "1.6" }}>
                                                      {t('functions.cards.offerManager.description')}
                                                </p>
                                                <button style={{
                                                      padding: "1rem 2rem",
                                                      backgroundColor: "#ff4d30",
                                                      color: "white",
                                                      border: "none",
                                                      borderRadius: "5px",
                                                      cursor: "pointer",
                                                      fontSize: "1.1rem"
                                                }}>{t('functions.cards.offerManager.button')}</button>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>
            </>
      );
}

export default Functions;
